// src/components/FloatingChatWidget.jsx
import React, { useState, useEffect } from "react";
import "../style/FloatingChatWidget.css";
import logo from "../assets/logo.png";
import { FaWhatsapp, FaTicketAlt } from "react-icons/fa";

const FloatingChatWidget = () => {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check if already shown in this session
    const hasShown = sessionStorage.getItem("chatWidgetShown");
    if (!hasShown) {
      const openTimer = setTimeout(() => handleOpen(), 1000);

      const closeTimer = setTimeout(() => {
        handleClose();
        sessionStorage.setItem("chatWidgetShown", "true");
      }, 6000);

      return () => {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
      };
    }
  }, []);

  const handleOpen = () => {
    setOpen(true);
    setTimeout(() => setVisible(true), 10);
  };

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => setOpen(false), 300);
  };

  const whatsappNumber = "918017353535"; // replace with your number
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=Hello`;

  return (
    <>
      <button
        className="chat-float-btn"
        onClick={() => (open ? handleClose() : handleOpen())}
      >
        💬
      </button>

      {open && (
        <div className={`chat-widget ${visible ? "open" : "closing"}`}>
          <button className="chat-close" onClick={handleClose}>
            ✖
          </button>
          <div className="chat-welcome">
            <img src={logo} alt="Logo" className="chat-logo" />
            <p>Welcome to Great Eastern Trading Co.</p>
            <p>
              If you have any issue, you can connect with us via{" "}
              <strong>WhatsApp</strong> or raise a{" "}
              <strong>Support Ticket</strong>.
            </p>

            {/* WhatsApp Button */}
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="chat-whatsapp-btn"
            >
              <FaWhatsapp className="whatsapp-icon" /> Connect on WhatsApp
            </a>

            {/* Support Ticket Button */}
            <a href="/customersupport" className="chat-ticket-btn">
              <FaTicketAlt className="ticket-icon" /> Raise Support Ticket
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default FloatingChatWidget;
